import React from "react";
import { useState } from "react";
import axios from 'axios'
import { GrTwitter, GrFacebook, GrInstagram, GrYoutube } from "react-icons/gr";
const SERVER_URL = process.env.REACT_APP_SERVER_URL


const Footer = () => {
  const [email, setEmail] = useState("")
  const [isSubscribed, setIsSubscribed] = useState(false)
  const footerIcons = [
    "https://cdn-icons-png.flaticon.com/512/196/196566.png",
    "https://cdn-icons-png.flaticon.com/512/6124/6124998.png",
    "https://cdn-icons-png.flaticon.com/512/196/196578.png",
    "https://cdn-icons-png.flaticon.com/512/5977/5977576.png",
    "https://cdn-icons-png.flaticon.com/512/5968/5968382.png",
  ];

  const faqs = [
    "Payment",
    "Shipping",
    "Returns",
    "Gift Card",
    "Electronic Receipt",
    "Terms & Conditions",
  ];

  return (
    <div className="footer-main">
      <div className="footer-upper-container">
        <div className="col-3 footer-upper-cols">
          <h5 className="footer-head">STORE</h5>
          <p className="body-text" style={{ marginBottom: "5px" }}>
            269 Elizabeth Ave Sir, Brooklyn,
          </p>
          <p className="body-text">CA, 90025</p>
          <p className="body-text">+0082 561 43 34</p>
          <p className="body-text">support@store.com</p>
          <div style={{ marginTop: "50px" }}>
            <h6 className="footer-head-mobile" style={{ marginBottom: "20px" }}>KEEP IN TOUCH</h6>
            <div className="sm-icons-row ">
              <GrTwitter className="footer-icons" />
              <GrFacebook className="footer-icons" />
              <GrInstagram className="footer-icons" />
              <GrYoutube className="footer-icons" />
            </div>
          </div>
        </div>
        <div className="col-2 footer-upper-cols">
          <h6 className="footer-head">FAQS</h6>
          {faqs.map((faq) => (
            <p className="body-text">{faq}</p>
          ))}
        </div>
        <div className="col-2 footer-upper-cols">
          <h6 className="footer-head">COMPANY</h6>
          <p className="body-text">About Store</p>
          <p className="body-text">Contact</p>
          <p className="body-text">Careers</p>
          <p className="body-text">Our Journals</p>
        </div>
        <div className="col-4 footer-upper-cols">
          <h6 className="footer-head">NEWSLETTER</h6>
          <p className="body-text footer-temp" >
            Be the first to get the latest news about trends, promotions
          </p>
          <p className="body-text">and much more!</p>
          <input type="email" placeholder="Enter your email address" onChange={(e) => {
            setEmail(e.target.value)
          }} />
          <p className="footer-input-p">
            By subscribing , you accept the <span>privacy policy</span>
          </p>
          {isSubscribed ?
            <button className="newsletter-subs-btn"
              disabled={true}
              style={{backgroundColor:"gray"}}
            >SUBSCRIBED</button>
            :
            <button className="newsletter-subs-btn"
              onClick={() => {
                if (localStorage.getItem("userTokenTime") != null) {
                  if (email === JSON.parse(localStorage.getItem("email"))) {
                    console.log(email)
                    setIsSubscribed(true);
                    axios
                      .post(
                        SERVER_URL +
                        "/api/subscribe-newsletter",
                        {
                          email: email
                        },
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer " +
                              JSON.parse(localStorage.getItem("userTokenTime")).token,
                          },
                        }
                      )
                      .then((res) => {
                        console.log(res.data);
                      }).catch((e) => {
                        console.log(e);
                      });
                  }
                }
              }}
            >SUBSCRIBE</button>
          }

        </div>
      </div>
      <hr />
      <div className="footer-lower-container">
        <div className="footer-lower-cols">
          &#169; 2023 STORE. ALL RIGHTS RESERVED
        </div>
        <div className="footer-lower-cols">
          <div style={{ marginRight: "15px", color: "black" }}>EN(US)</div>
          <div>EN(UK)</div>
        </div>
        <div className="footer-lower-cols">
          {footerIcons.map((iconSrc) => (
            <div>
              <img className="footer-payment-icons" src={iconSrc} alt="" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Footer;
